import { defaultTheme } from 'react-admin';
import reportWebVitals from '../reportWebVitals';

export const mainTheme = {
  ...defaultTheme,
  palette: {
    primary: {
      main: '#4f3cc9', //accent color
    },
    secondary: {
      light: '#5f5fc4', //light accent
      main: '#283593', // middle accent
      dark: '#001064', // dark accent
      contrastText: '#fff',
    },
    background: {
      default: '#fcfcfe',
    },
  },
  shape: {
    // borderRadius: 10,
  },
  sidebar: {
    width: 200,
  },
  components: {
    ...defaultTheme.components,
    RaLayout: {
      styleOverrides: {
        // The content area is a flex item; without min-width:0 it grows to fit
        // wide children (e.g. /seo tables) and gets pushed off-screen when the
        // sidebar is open. min-width:0 lets it shrink so wide tables scroll
        // inside their own containers instead of clipping the page.
        content: {
          minWidth: 0,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'filled' as any, //outlined
      },
    },
    RaMenuItemLink: {
      styleOverrides: {
        root: {
          borderLeft: '3px solid #fff',
          '&.RaMenuItemLink-active': {
            borderLeft: '3px solid #4f3cc9',
          },
        },
      },
    },
    MuiBox: {
      styleOverrides: {
        root: {
          color: 'purple',
          'margin-top': 0,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation4: {
          boxShadow: 'none',
        },
        root: {
          border: '1px solid #e0e0e3',
          backgroundClip: 'padding-box',
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        // disable ripple for perf reasons
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          '&:hover:active::after': {
            // recreate a static ripple color
            // use the currentColor to make it work both for outlined and contained buttons
            // but to dim the background without dimming the text,
            // put another element on top with a limited opacity
            content: '""',
            display: 'block',
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            right: 0,
            backgroundColor: 'currentColor',
            opacity: 0.3,
            borderRadius: 'inherit',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorSecondary: {
          color: '#1A1B25',
          backgroundColor: '#fff',
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: '#f5f5f5',
        },
        barColorPrimary: {
          backgroundColor: '#d7d7d7',
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
          '&$disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        },
      },
    },
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          border: 'none',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        body2: {
          color: '#404452',
        },
      },
    },
    RaSimpleShowLayout: {
      styleOverrides: {
        root: {
          '& .RaSimpleShowLayout-row': {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            // borderBottom: '1px solid #f0f0f0',
            // padding: '8px 0',
          },
        },
      },
    },
    RaLabeled: {
      styleOverrides: {
        root: {
          color: 'black',
          display: 'flex',
          width: '100%',
          '& .RaLabeled-label': {
            fontSize: 14,
            minWidth: '200px',
            width: '30%',
            fontWeight: 'bold',
            paddingRight: '16px',
            // textAlign: 'right',
          },
          '& .RaLabeled-value': {
            flex: 1,
          },
        },
      },
    },
  },
};
